import {writable} from 'svelte/store';

const REFERRAL_KEY = 'reset-security';

export const resetSecurity$ = writable(readLocalReferral());

resetSecurity$.subscribe(({email, code}) => {
  if (!process.browser || !email || email === 'null') {
    return;
  }

  localStorage.setItem(REFERRAL_KEY, [email || '', code || ''].join(','));
});

function readLocalReferral() {
  if (process.browser) {
    const resetSecurity = localStorage.getItem(REFERRAL_KEY);
    if (resetSecurity) {
      const [email, code] = resetSecurity.split(',');
      return {email: email === 'null' ? '' : email, code};
    }
  }

  return {email: '', code: ''};
}
